// imageUtils.js
// Use the same base URL resolution as the API client to avoid hardcoded localhost in production.
import { API_BASE_URL } from '../config/api';

// Kleine In-Memory-Cache-Speicher
const imageUrlCache = new Map();

export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;

  // Schneller Cache-Hit
  if (imageUrlCache.has(imagePath)) {
    return imageUrlCache.get(imagePath);
  }

  // If it's already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    imageUrlCache.set(imagePath, imagePath);
    return imagePath;
  }

  // If it's a relative path starting with /uploads, use direct uploads URL (served statically)
  if (imagePath.startsWith('/uploads/')) {
    // Prefer requesting the file directly from /uploads to avoid hitting the /api/ rate limiter.
    // This path is served by express.static on the server and benefits from long-term caching.
    const url = imagePath;
    imageUrlCache.set(imagePath, url);
    return url;
  }

  // Handle old format without /uploads prefix (e.g. "pins/filename" or ".../pins/filename")
  // Accept forms with or without a leading slash, e.g. "pins/.." or "/pins/.."
  if (/(^|\/)(pins|avatars)\//.test(imagePath)) {
    // Extract type and filename from old format and map to /uploads route
    const parts = imagePath.split('/');
    const typeIndex = parts.findIndex(part => part === 'pins' || part === 'avatars');
    if (typeIndex !== -1) {
      const type = parts[typeIndex];
      const filename = parts.slice(typeIndex + 1).join('/');
      // Serve from the static uploads path to avoid /api/ rate limiting
      const url = `/uploads/${type}/${filename}`;
      imageUrlCache.set(imagePath, url);
      return url;
    }
  }

  // Otherwise, assume it's a relative path and prepend the API base URL
  const finalUrl = `${API_BASE_URL}${imagePath}`;
  imageUrlCache.set(imagePath, finalUrl);
  return finalUrl;
};

export const getAvatarUrl = (avatarPath) => {
  return getImageUrl(avatarPath);
};
export const getPinImageUrl = (imagePath) => {
  return getImageUrl(imagePath);
};
